import { render } from "./SalesSpecial.vue?vue&type=template&id=3807fcda&lang=true"
import script from "./SalesSpecial.vue?vue&type=script&lang=js"
export * from "./SalesSpecial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/StartUpIcons/SalesSpecial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3807fcda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3807fcda', __exports__)) {
    api.reload('3807fcda', __exports__)
  }
  
  module.hot.accept("./SalesSpecial.vue?vue&type=template&id=3807fcda&lang=true", () => {
    api.rerender('3807fcda', render)
  })

}


export default __exports__